// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents inobtained
// from Xngage LLC.
//

import xProductPartNumbersStyles from "@sc/App/SharedStyles/ProductPartNumbersStyles";
import { manufacturingPartNumberStyles } from "@sc/Overrides/Widgets/ProductDetails/ProductDetailsManufacturingPartNumber";
import { css } from "styled-components";

manufacturingPartNumberStyles.labelText = {
    ...xProductPartNumbersStyles.label,
    css: css`
        ${xProductPartNumbersStyles.label?.css}
        font-size: 14px;
        line-height: 22px;
    `,
};
manufacturingPartNumberStyles.valueText = {
    ...xProductPartNumbersStyles.value,
    css: css`
        ${xProductPartNumbersStyles.value?.css}
        font-size: 14px;
        line-height: 22px;
    `,
};

manufacturingPartNumberStyles.wrapper = {
    css: css`
        display: flex;
    `,
};
